// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","container":"LoadingPage_container__Ve6lo"};